import Vue from 'vue'


// import authentication system
import { AuthConfig } from '@/auth/utils'
const { axiosIns } = AuthConfig


// base options
const baseDomain = process.env.VUE_APP_API_URL;
const baseURL =  `${baseDomain}`;

axiosIns.defaults.baseURL = baseURL
axiosIns.defaults.timeout = 18000
axiosIns.defaults.withCredentials = true


// axios interceptor to check the intension
axiosIns.interceptors.request.use(
    async (config)=>{

        return config
    },
        error => Promise.reject(error),
)


// axios notifications
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

axiosIns.interceptors.response.use(
    (response)=>{

        let toastConfig = null
        // На каждый GET всплывало «Объект получен» — это шум: чтение данных происходит
        // на каждом открытии страницы и подтверждения не требует. Уведомления оставлены
        // только на изменяющих операциях.
        if (response.config.method === "post") {

            toastConfig = {
                component: ToastificationContent,
                props: {
                    title: `Обьект добавлен`,
                    icon: 'CoffeeIcon',
                    text: `Обьект успешно добавлен`,
                    variant: 'success',
                }
            }
        }

        if (response.config.method === "put" || response.config.method === "patch") {
            toastConfig = {
                component: ToastificationContent,
                props: {
                    title: `Обьект обновлен`,
                    icon: 'CoffeeIcon',
                    text: `Обьект успешно обновлен`,
                    variant: 'success',
                }
            }
        }

        if (response.config.method === "delete") {
            toastConfig = {
                component: ToastificationContent,
                props: {
                    title: `Обьект удален`,
                    icon: 'CoffeeIcon',
                    text: `Обьект успешно удален`,
                    variant: 'success',
                }
            }
        }

        if (toastConfig) Vue.$toast(toastConfig)

        return response
    },
    (error) => {
        let toastConfig = null
        if (error.config.method === "get") {
            toastConfig = {
                component: ToastificationContent,
                props: {
                    title: `Ошибка получения`,
                    icon: 'AlertTriangleIcon',
                    text: `Не удалось получить обьекты, попробуйте позже или свяжитесь с администратором`,
                    variant: 'danger',
                }
            }
        }
        if (error.config.method === "post") {

            toastConfig = {
                component: ToastificationContent,
                props: {
                    title: `Ошибка добавления`,
                    icon: 'AlertTriangleIcon',
                    text: `Не удалось добавить обьекты, попробуйте позже или свяжитесь с администратором`,
                    variant: 'danger',
                }
            }
        }

        if (error.config.method === "put" || error.config.method === "patch") {
            toastConfig = {
                component: ToastificationContent,
                props: {
                    title: `Ошибка обновления`,
                    icon: 'AlertTriangleIcon',
                    text: `Не удалось обновить обьекты, попробуйте позже или свяжитесь с администратором`,
                    variant: 'danger',
                }
            }
        }

        if (error.config.method === "delete") {
            toastConfig = {
                component: ToastificationContent,
                props: {
                    title: `Ошибка удаления`,
                    icon: 'AlertTriangleIcon',
                    text: `Не удалось удалить обьекты, попробуйте позже или свяжитесь с администратором`,
                    variant: 'danger',
                }
            }
        }

        if (toastConfig) Vue.$toast(toastConfig)

        return Promise.reject(error);
    }
)


Vue.prototype.$http = axiosIns;

export default axiosIns
